import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconBookingComRectangle = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props} ref={ref}>
    <g clipPath="url(#clip0_5098_130892)">
      <rect x="0.399902" width="24" height="24" rx="6" fill="#0C3B7C" />
      <path
        d="M11.3074 15.8865L9.37433 15.8845V13.5212C9.37433 13.0162 9.5659 12.7534 9.98851 12.6934H11.3074C12.2479 12.6934 12.8563 13.2997 12.8563 14.2811C12.8563 15.289 12.2633 15.8855 11.3074 15.8865ZM9.37433 9.51203V8.88994C9.37433 8.34562 9.59959 8.08674 10.0934 8.05327H11.0831C11.9312 8.05327 12.4395 8.57201 12.4395 9.44117C12.4395 10.1026 12.091 10.8753 11.1139 10.8753H9.37433V9.51203ZM13.7756 11.8705L13.4262 11.6697L13.7314 11.4029C14.0866 11.0909 14.6815 10.3891 14.6815 9.17835C14.6815 7.32389 13.275 6.12794 11.0985 6.12794H8.61478V6.12695H8.33176C7.68677 6.15156 7.16982 6.68802 7.16309 7.35146V17.8738H11.1476C13.5667 17.8738 15.1282 16.5273 15.1282 14.4415C15.1282 13.3184 14.6237 12.3587 13.7756 11.8705Z"
        fill="white"
      />
      <path
        d="M16.1658 16.4209C16.1658 15.6171 16.7998 14.9668 17.581 14.9668C18.3642 14.9668 19.0012 15.6171 19.0012 16.4209C19.0012 17.2237 18.3642 17.8751 17.581 17.8751C16.7998 17.8751 16.1658 17.2237 16.1658 16.4209Z"
        fill="#00BAFC"
      />
    </g>
    <defs>
      <clipPath id="clip0_5098_130892">
        <rect x="0.399902" width="24" height="24" rx="6" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const IconBookingComRectangle = forwardRef(_IconBookingComRectangle)
